import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import React from 'react';
import Articles from '../Articles';
import { LINKS } from '@/constants/links';
import { ArticleBoxProps } from '@/components/boxes';
export function WroteAboutUs(t0) {
  const $ = _c(12);
  const {
    items
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["aboutUs"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("wroteAboutUs.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("wroteAboutUs.cta");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = LINKS();
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = {
      analyticsParam: "wroteAboutUsSectionViewAll",
      label: t3,
      link: t4.wroteAboutUs,
      testId: "wroteAboutUsSectionViewAll"
    };
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== items || $[9] !== t2 || $[10] !== t5) {
    t6 = <Articles title={t2} button={t5} articles={items} articlesTarget="_blank" className="py-0!" />;
    $[8] = items;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}